import { createStore } from 'satcheljs';
import DictationStore from './schema/DictationStore';

const dictationStoreData: DictationStore = {
    isDictationOn: false,
};

export const getDictationStore = createStore<DictationStore>('dictationStore', dictationStoreData);
export { DictationStore };
